module.exports = __webpack_public_path__ + "img/parallax1-1200p.cb845ec0.jpg";